import makeStyles from '@material-ui/core/styles/makeStyles';
import { ERebrandingColors } from 'helpers/constants';

const useStyles = makeStyles(() => ({
  presetDates: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    flexDirection: 'row',
    marginTop: '.5rem',
  },
  presetItem: {
    minHeight: 38,
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: 700,
    margin: 0,
    transition: 'all .3s ease-in-out',
    '& > span': {
      color: '#fff',
      '&:first-child': {
        opacity: 0,
        visibility: 'hidden',
        display: 'none',
      },
    },
    '&:first-child': {
      borderRadius: '5px 0 0 5px',
    },
    '&:last-child': {
      borderRadius: '0 5px 5px 0',
    },
    '&:hover': {
      backgroundColor: ERebrandingColors.MAIN,
    },
    backgroundColor: '#B0BEC5',
    '&.--active': {
      backgroundColor: ERebrandingColors.MAIN,
    },
    '&.--disabled': {
      '&:hover': { backgroundColor: '#B0BEC5' },
    },
  },
  label: { fontSize: 15 },
  advancedFields: { marginTop: 10 },
  labelContainer: {
    display: 'flex',
    gap: '1rem',
    '& p': {
      margin: '0',
      lineHeight: '1',
    },
  },
  calendar: {
    width: 'auto',
    flex: '1',
    '& .DateRangePickerInput__withBorder': {
      borderRadius: '4px 0 0 4px !important',
    },
  },
  calendarIcon: {
    padding: '0 1rem',
    display: 'flex',
    color: '#fff',
    alignSelf: 'stretch',
    borderRadius: '0 5px 5px 0',
    cursor: 'pointer',
    backgroundColor: '#B0BEC5',
    '&:hover': {
      backgroundColor: ERebrandingColors.MAIN,
    },
    '&.--disabled:hover': {
      backgroundColor: '#B0BEC5',
      cursor: 'auto',
    },
    '&.--closeCalendar:hover': {
      backgroundColor: '#F44336',
    },
  },
}));

export default useStyles;
